import React, { useEffect, useState } from "react";
import {
  Chip,
  CircularProgressBar,
  InfoTimeCardAdv,
  Modal,
  TableAdv,
} from "../../../../../components";
import { fetchSmartInsightsJobsData } from "../../../../../redux/slices/bdmjobs/bdmjobsApi";
import { mapTableRows } from "../../../../../utils";
import { usePagination } from "../../../../../hooks";
import { formatWords2 } from "../../../../../utils/stringUtils";

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

const SmartInsights = ({ jobSmartInsights, skills, jobPostId }) => {
  const { page, limit, setPage, handleLimitChange } = usePagination(
      10,
      (newPage, newLimit) => { }
    );
  const [diffJobs, setDiffJobs] = useState([]);
  const [sameJobs, setSameJobs] = useState([]);
  const [isModelopen, setIsModelOpen] = useState(false);

  const columns = [
    {
      key: "jobTitle",
      label: "Job Title",
      columnMenu: false
    },    
    {
      key: "jobCreatedOn",
      label: "Job Created On",
      columnMenu:false
    },
    {
      key: "jobCreatedBy",
      label: "Job Created By",
      columnMenu:false
    },
    {
      key: "accountName",
      label: "Account Name",
      columnMenu:false
    },
    {
      key: "accountCreatedOn",
      label: "Account Created Date",
      columnMenu:false
    },
    {
      key: "accountCreatedBy",
      label: "Account Created By",
      columnMenu:false
    },    
    {
      key: "submissionCount",
      label: "Submission Count",
      columnMenu:false
    },
  ];

  const rows = diffJobs?.map(item => ({
    jobTitle: formatWords2(item?.jobTitle),
    accountName: formatWords2(item?.accountName),
    jobCreatedOn: formatDate(item?.jobCreatedOn),
    jobCreatedBy: formatWords2(item?.jobCreatedBy?.firstName) + " " + formatWords2(item?.jobCreatedBy?.lastName),
    accountCreatedBy: formatWords2(item?.accountCreatedBy?.firstName) + " " + formatWords2(item?.accountCreatedBy?.lastName),
    accountCreatedOn: formatDate(item?.accountCreatedOn),
    submissionCount: item?.submissionCount
  }));

  const mappedRows = mapTableRows(rows, columns);

  const fetchDiffCompanyJobs = async () => {
    const response = await fetchSmartInsightsJobsData({
          coll: "JobPosting",
          fil: {
            uiid: {
              type: "SMART_INSIGHTS_DIFF_COMPANY_JOBS",
              value: "",
              jobPostId,
            },
          },
          useAggregate: true,
          lim: limit,
          pg: page,
        });

    if (response?.success) {
      setDiffJobs(response?.data?.data);
    }
  };

  // const fetchSameCompanyJobs = async () => {
  //   const response = await fetchSmartInsightsJobsData({
  //         coll: "JobPosting",
  //         fil: {
  //           uiid: {
  //             type: "SMART_INSIGHTS_SAME_COMPANY_JOBS",
  //             value: "",
  //             jobPostId,
  //           },
  //         },
  //         useAggregate: true,
  //       });

  //   if (response?.success) {
  //     setSameJobs(response?.data?.data);
  //   }
  // };

  useEffect(() => {
    fetchDiffCompanyJobs();
    // fetchSameCompanyJobs();
  }, [jobPostId, page, limit])

  return (
    <>
      <div className="flex flex-col">
        <h6>Smart Insights</h6>
        <div className="flex items-stretch gap-3 my-4">
          <div className="inner-section flex flex-col flex-1  rounded">
            <p className="py-3 px-2 border-b rounded border-[#e7e7e7] bg-primary-50 mb-5">
              Hire Probability
            </p>
            <CircularProgressBar value={jobSmartInsights?.hireProbability || 0} />
          </div>
          <div className="flex-1 inner-section rounded">
            <p className="py-3 px-2 border-b rounded border-[#e7e7e7] bg-primary-50">
              Skills
            </p>
            <div className="p-4">
              {skills.map((skill) => <Chip
                label={skill}
                color="primary"
                variant="outlined"
                className="bg-primary-50 !rounded-full m-2 px-4 py-1"
              />)}
            </div>
          </div>
          <div className="inner-section flex-[2] rounded">
            <p className="py-3 px-2 border-b rounded border-[#e7e7e7] bg-primary-50">
              Kult Work Data
            </p>
            <div className="flex gap-4">
              <div className="flex flex-col gap-2 p-2">
                <InfoTimeCardAdv
                  title="Opened Multiple Time"
                  value={jobSmartInsights?.sameTitleDifferentCompanies || 0}
                  variant={"text"}
                  color={"primary"}
                  onClick={() => setIsModelOpen(true)}
                />
                <InfoTimeCardAdv
                  title="Opened with same company name"
                  value={jobSmartInsights?.sameTitleSameCompany || 0}
                  variant={"text"}
                  color={"primary"}
                />
              </div>
              <div className="flex flex-col gap-2 p-2 justify-center ">
                <div className="flex items-center my-1 border-b border-gray-300">
                  <span className="text-xs  flex-1">Similar Job</span>
                  <span className="text-xs  pl-2">{jobSmartInsights?.similarJobTitles || 0}</span>
                </div>

                <div className="flex items-center border-b border-gray-300 my-1">
                  <span className="text-xs  flex-1">Similar Job closed</span>
                  <span className="text-xs pl-2">{jobSmartInsights?.similarClosedJobs || 0}</span>
                </div>

                <div className="flex items-center border-b border-gray-300  my-1">
                  <span className="text-xs flex-1">Job from same client</span>
                  <span className="text-xs pl-2">{jobSmartInsights?.jobsFromSameCompany || 0}</span>
                </div>

                <div className="flex items-center border-b border-gray-300  my-1">
                  <span className="text-xs flex-1">
                    Job from same client closed
                  </span>
                  <span className="text-xs pl-2">{jobSmartInsights?.closedJobsFromSameCompany || 0}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={isModelopen}
        onClose={() => setIsModelOpen(false)}
        title={'Jobs Opened Multiple Times'}
        titleColor={'primary'}
        width="max-w-7xl"
      >
        <TableAdv
          tableId={"jobs_jobdetails_smartinsights_table"}
          rows={mappedRows}
          columns={columns}
          serverPagination={true}
          totalCount={jobSmartInsights?.sameTitleDifferentCompanies}
          page={page}
          limit={limit}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          toolbarRight={{
            fullScreen:true
          }}
        />
      </Modal>
    </>
  );
};

export default SmartInsights;
